import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {item.q}
                </span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-5 md:px-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}